export default __webpack_public_path__ + "static/media/phuctinhqn.68b8966c.png";